import React from 'react';
import Navbar from '../components/Navbars/AppNavbar.js';
import Footer from '../components/Footers/Footer.js';
import FooterSM from '../components/Footers/FooterSmall.js';
import CollectorsComponent from '../components/Collectors/index';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

export default function Collectors() {
  const SEO = {
    title: 'MusicArt | Collectors',
    description: 'Search for Collectors',
    canonical: 'https://musicart.io/collectors',
  };
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        {/* <Link  rel="canonical" href="https://musicart.io/collectors" /> */}
      </Head>
      <NextSeo {...SEO} />
      <Navbar transparent />
      <CollectorsComponent />
      <Footer />
      <FooterSM />
    </>
  );
}
